import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  TimePeriodUnsegmentedViz,
  TimePeriodUnsegmentedVizProps,
} from '../../data-viz-containers/time-period-unsegmented/TimePeriodUnsegmentedViz';
import { TimePeriodUnsegmentedVizViews } from '../../data-viz-containers/time-period-unsegmented/types';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { TimePeriodUnsegmentedStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: TimePeriodUnsegmentedStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
): TimePeriodUnsegmentedVizProps => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: {
      ...externalProps,
      selectedView: componentConfig.selectedView,
    },
    persistenceKey,
  };
};

export const timePeriodUnsegmentedStoryboardComponentSettings: StoryboardComponentSettings<
  TimePeriodUnsegmentedStoryboardComponentConfig,
  TimePeriodUnsegmentedVizProps
> = {
  componentId: StoryboardComponentIds.TIME_PERIOD_UNSEGMENTED,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: TimePeriodUnsegmentedViz,
  validateConfig: (componentConfig) => {
    const { queries, benchmarkConfigs } = componentConfig.dataConfig;
    if (
      queries.length > 1 &&
      componentConfig.selectedView === TimePeriodUnsegmentedVizViews.PIE_CHART
    ) {
      return {
        isValid: false,
        error: new Error(
          'Pie chart view not supported on unsegmented time period chart'
        ),
      };
    }
    if (benchmarkConfigs?.length) {
      if (
        componentConfig.selectedView !== TimePeriodUnsegmentedVizViews.PIE_CHART
      ) {
        return {
          isValid: false,
          error: new Error(
            'benchmarkConfigs are only supported for pie chart view on time period unsegmented charts'
          ),
        };
      }
      if (queries.length !== 1) {
        return {
          isValid: false,
          error: new Error(
            'benchmarkConfigs require exactly one metric query on time period unsegmented charts'
          ),
        };
      }
      if (benchmarkConfigs.length > 1) {
        return {
          isValid: false,
          error: new Error(
            'At most one benchmarkConfig entry is supported for time period unsegmented pie charts'
          ),
        };
      }
    }
    return {
      isValid: true,
      error: null,
    };
  },
};
